import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError } from "@utils/errorHandler";

import {
  loadAllSellingPrices,
  loadSingleSellingPrice,
} from "./SellingPricesList.slice";

import {
  loadAllSellingPricesAPI,
  loadSingleSellingPriceAPI,
} from "./SellingPricesList.api";

export const LOAD_ALL_SELLING_PRICES = {
  LOADING: "Load all selling prices loading",
  SUCCESS: "Load all selling prices success",
  ERROR: "Load all selling prices error",
};

export const LOAD_SINGLE_SELLING_PRICE = {
  LOADING: "Load single selling price loading",
  SUCCESS: "Load single selling price success",
  ERROR: "Load single selling price error",
};

function* loadAllSellingPricesWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllSellingPricesAPI, payload);
    yield put(loadAllSellingPrices(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_SELLING_PRICES.ERROR, error });
  }
}

function* loadSingleSellingPriceSagaWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadSingleSellingPriceAPI, payload);
    yield put(loadSingleSellingPrice(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_SELLING_PRICE.ERROR, error });
  }
}

export function* loadAllSellingPricesSaga() {
  yield takeLatest(LOAD_ALL_SELLING_PRICES.LOADING, loadAllSellingPricesWorker);
}

export function* loadSingleSellingPriceSaga() {
  yield takeLatest(
    LOAD_SINGLE_SELLING_PRICE.LOADING,
    loadSingleSellingPriceSagaWorker
  );
}
